import React from "react";
import appTheme from "./appTheme"
import ShowEventDataOnHome from "./components/mainapp";
import { useState, useContext } from "react";
import { useEffect } from "react";
import { Auth } from "aws-amplify";
import { withAuthenticator, AmplifySignOut } from "@aws-amplify/ui-react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ActorOut from "./components/actorOut";
import ActorIn from "./components/actorIn";
import EventList from "./components/eventList";
import EventDetails from "./components/eventdetails";
import Participant from "./components/participant";
import ParticipantOverview from "./components/participantOverview";
import Volunteers from "./components/volunteers";
import Actives from "./components/actives";
import Unassigned from "./components/unassigned";
import ParticipantAdd from "./components/participantAdd";
import EventUpdate from "./components/eventUpdate";
import ConfigData from "./config.json";
import DisplayHistory from "./components/displayHistory";
import TestDimensions from "./components/testDimensions";
// import FlowDisplay from "./components/flowDisplay"

import EventContext from "./store/event-context";

import Alert from '@mui/material/Alert';
import { CssBaseline, Container } from '@mui/material';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
//import makeStyles from '@mui/styles/makeStyles';


//const theme = createTheme();
//const useStyles = makeStyles((theme) => {
//  root: {
//    // some CSS that access to theme
//  }
//});

function App() {
  const [currentUser, setCurrentUser] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [messages, setMessages] = useState(
    JSON.parse(localStorage.getItem("messages")) || [{}]
  );
  // const {foundMessage, sendMessage  } = useWebsocketService(ConfigData.websocket);
  const eventctx = useContext(EventContext);
  //const classes = useStyles(); // ❌ If you have this, consider moving it inside a component that wrapped with <ThemeProvider>

  // Get token from authorization
  // Auth.currentAuthenticatedUser().then(res=>{
  //     console.log("get user info from session")
  //     let position = res.signInUserSession.accessToken.payload["cognito:groups"].indexOf("admin")
  //     setIsAdmin(position>=0)
  // })

  const appendMessage = (message) => {
    // keep last 100 messages
    if (isAdmin) {
      if (message.includes(": ")) {
        const splitted = message.split(": ");
        setMessages([
          { id: messages.length, time: splitted[0], message: splitted[1] },
          ...messages,
        ]);
      } else {
        setMessages([
          { id: messages.length, time: "", message: message },
          ...messages,
        ]);
      }
    }
  };

  const clearMessages = (startFrom) => {
    setMessages((messages) => messages.slice(0, startFrom));
  };

  useEffect(() => {
    localStorage.setItem("messages", JSON.stringify(messages));
  }, [messages]);

  useEffect(() => {
    const getIsAdmin = async () => {
      const res = await Auth.currentAuthenticatedUser();
      //console.log("CurrentAuthenticatedUser: ", res);
      const adminPos =
        res.signInUserSession.accessToken.payload["cognito:groups"].indexOf(
          "admin"
        );
       setCurrentUser(res.signInUserSession.accessToken.payload.username);
      console.log(adminPos >= 0 ? "User is admin" : "User is NOT admin");
      setIsAdmin(adminPos >= 0);
    };
    getIsAdmin();
  }, [setIsAdmin]);

  const hasEventData = eventctx.eventId !== "";

  return (
    <StyledEngineProvider injectFirst>
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <Container id="App-container" disableGutters sx={{ width: '98%'}}>
        {!hasEventData && <EventList />}
        <Router>
          <EventDetails username={currentUser} isAdmin={isAdmin} />
          <Switch>
            <Route path="/participants">
              {hasEventData && <Participant />}
            </Route>
            <Route path="/actorsIn">{hasEventData && <ActorIn />}</Route>
            <Route path="/actorsOut">{hasEventData && <ActorOut />}</Route>
            <Route path="/active">{hasEventData && <Actives />}</Route>
            {isAdmin && (
              <Route path="/overview">
                {hasEventData && <ParticipantOverview />}
              </Route>
            )}
            {isAdmin && (
              <Route path="/volunteers">{hasEventData && <Volunteers />}</Route>
            )}
            {isAdmin && (
              <Route path="/unassigned">{hasEventData && <Unassigned />}</Route>
            )}
            {isAdmin && (
              <Route path="/participantAdd">{hasEventData && <ParticipantAdd />}</Route>
            )}
            {isAdmin && (
              <Route path="/eventUpdate">{hasEventData && <EventUpdate />}</Route>
            )}
            {isAdmin && (
              <Route path="/testDimensions">{hasEventData && <TestDimensions />}</Route>
            )}
            {isAdmin && (
              <Route path="/logs">
                <DisplayHistory
                  messages={messages}
                  clearMessages={clearMessages}
                />
              </Route>
            )}
            <Route path="/">
                <ShowEventDataOnHome
                  version={ConfigData.version}
                />
            </Route>
            <Route path="/signout">
              <AmplifySignOut />
            </Route>
          </Switch>
        </Router>

        {/* <FlowDisplay foundMessage={foundMessage} appendMessage={appendMessage}/> */}
      </Container>
    </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default withAuthenticator(App);

// https://docs.amplify.aws/ui-legacy/auth/authenticator/q/framework/react
// https://docs.amplify.aws/ui/auth/authenticator/q/framework/react#sign-in
